import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivityRestored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 23,
	viewBox: "0 0 21 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.04395 12.9813L9.46394 15.7212L14.1739 10.0312",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.57492 8.7802C-0.0750806 12.2302 0.474918 16.4902 3.27492 19.4202C6.88492 23.2002 12.8849 23.3302 16.6549 19.7202C20.4349 16.1102 20.5649 10.1102 16.9549 6.3402C14.1649 3.4302 9.96492 2.68019 6.45492 4.15019",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.39531 0.650391L6.44531 4.15039L9.94531 6.10039",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgActivityRestored;
